import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { OFFERS } from "@/data/offers";
import { useLang } from "@/lib/siteI18n";

export default function Services() {
  const { t } = useLang();
  const offers = OFFERS.map((o) => ({ ...o, ...(t.services.offers[o.slug] || {}) }));
  return (
    <div className="pt-32 pb-24" data-testid="services-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="max-w-3xl mb-20">
          <p className="text-xs uppercase tracking-luxe text-gold mb-6">{t.services.kicker}</p>
          <h1 className="font-serif text-5xl md:text-7xl text-white leading-[0.95]">
            {t.services.title}
          </h1>
          <p className="text-white/60 font-light text-lg mt-8 leading-relaxed">
            {t.services.intro}
          </p>
        </Reveal>

        <div className="space-y-px bg-white/10 border border-white/10">
          {offers.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.05}>
              <div
                data-service-card={s.slug}
                className="bg-brand-ink p-8 md:p-12 grid md:grid-cols-12 gap-8 items-center group hover:bg-brand-surface transition-colors duration-500"
              >
                <div className="md:col-span-5">
                  <h2 className="font-serif text-3xl md:text-4xl text-white">{s.name}</h2>
                  <div className="mt-3 flex items-baseline gap-3">
                    <span className="font-serif text-3xl text-gold">{s.price}</span>
                  </div>
                  {s.note && (
                    <p className="mt-2 text-xs uppercase tracking-luxe text-gold/70">
                      {s.note}
                    </p>
                  )}
                </div>
                <div className="md:col-span-4">
                  <p className="text-white/60 font-light leading-relaxed mb-4">{s.desc}</p>
                  <ul className="space-y-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-2 text-sm text-white/50">
                        <Check size={14} className="text-gold shrink-0" strokeWidth={2} /> {p}
                      </li>
                    ))}
                  </ul>
                  {s.afterNote && (
                    <p className="mt-5 text-xs text-white/45 italic leading-relaxed">
                      {s.afterNote}
                    </p>
                  )}
                </div>
                <div className="md:col-span-3 md:text-right">
                  {s.href ? (
                    <a href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`service-cta-${s.slug}`}
                      className="inline-flex items-center gap-2 bg-gold text-brand-ink hover:bg-brand-gold-hover transition-colors px-7 py-4 text-xs uppercase tracking-[0.15em] font-semibold">
                      {s.ctaLabel} <ArrowUpRight size={16} />
                    </a>
                  ) : (
                    <Link to={s.to} data-testid={`service-cta-${s.slug}`}
                      className="inline-flex items-center gap-2 bg-gold text-brand-ink hover:bg-brand-gold-hover transition-colors px-7 py-4 text-xs uppercase tracking-[0.15em] font-semibold">
                      {s.ctaLabel} <ArrowUpRight size={16} />
                    </Link>
                  )}
                  {s.to && s.href && (
                    <p className="mt-3 text-xs text-white/40"><Link to={s.to} className="underline underline-offset-4 hover:text-gold" data-testid={`service-more-${s.slug}`}>{t.services.more}</Link></p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
